import { connect } from 'react-redux';
import NotificationPill from 'components/NotificationPill/NotificationPill';
import _get from 'lodash/get';

const mapActionCreators = () => ({});

const mapStateToProps = (state) => ({
  message: _get(state, 'app.notification.pill'),
  isMinimized: _get(state, 'app.inCallVideo.isMinimized')
});

export default connect(mapStateToProps, mapActionCreators)(NotificationPill);
